// extracted by mini-css-extract-plugin
export default {"link":"TabNav_link__gfw9P","active":"TabNav_active__5d17v","small":"TabNav_small__by70+"};